import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ConfirmActionDialog } from "@/components/ui/confirm-action-dialog";
import { useMarkUserOnboarded } from "@/lib/api/user";
import { CheckCircle2, Loader2 } from "lucide-react";

interface MarkOnboardedRowProps {
  userId: string;
  disabled?: boolean;
  hasOnboarded?: boolean;
}

export function MarkOnboardedRow({
  userId,
  disabled = false,
  hasOnboarded,
}: MarkOnboardedRowProps) {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const markUserOnboardedMutation = useMarkUserOnboarded();

  const handleConfirm = () => {
    markUserOnboardedMutation.mutate(
      { userId },
      { onSuccess: () => setShowConfirmDialog(false) },
    );
  };

  const getStatusText = () => {
    return hasOnboarded ? "Active" : "Not Onboarded";
  };

  return (
    <div className="flex items-center justify-between">
      <div>
      <span className="text font-medium text-neutral-500">User Onboarding Status: </span>
      <span
            className={` ${hasOnboarded ? "text-green-600" : "text-red-600" }`}
          >
            {getStatusText()}
          </span>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setShowConfirmDialog(true)}
        disabled={disabled || markUserOnboardedMutation.isPending}
        type="button"
        className="flex items-center gap-2"
      >
        {markUserOnboardedMutation.isPending ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <CheckCircle2 className="h-4 w-4" />
        )}
        {markUserOnboardedMutation.isPending
          ? "Updating..."
          : "Mark Onboarded"}
      </Button>

      <ConfirmActionDialog
        isOpen={showConfirmDialog}
        onClose={() => setShowConfirmDialog(false)}
        onConfirm={handleConfirm}
        title="Are you sure?"
        description="This cannot be undone. This will add the mentor to mentor matching."
        confirmText="Mark Onboarded"
        confirmVariant="default"
        loading={markUserOnboardedMutation.isPending}
      />
    </div>
  );
}
